export const SET_LOCATION_INFO = "SET_LOCATION_INFO";
